const ArrayHelper = {

  /**
   * // usage example:
   * var a = ['a', 1, 'a', 2, '1'];
   * var unique = a.filter(ArrayHelper.onlyUnique); // returns ['a', 1, 2, '1']
   *
   * @param value
   * @param index
   * @param self
   * @returns {boolean}
   */
  onlyUnique: function (value, index, self) {
    return self.indexOf(value) === index;
  },

  /**
   * How to use ?
   * arr.filter(ArrHelper.filterUnique(['name', 'age', ...etc]))
   *
   * @param props object.property
   *
   * @returns {Function} array filter format
   */
  onlyUniqueObj(props) {
    function compare(a, b) {
      let prop;
      if (props) {
        for (let j = 0; j < props.length; j++) {
          prop = props[j];
          if (a[prop] !== b[prop]) {
            return false;
          }
        }
      } else {
        for (prop in a) {
          if (a[prop] !== b[prop]) {
            return false;
          }
        }

      }
      return true;
    }
    return function (item, index, list) {
      for (let i = 0; i < index; i++) {
        if (compare(item, list[i])) {
          return false;
        }
      }
      return true;
    };
  }

};

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = ArrayHelper;
} else {
  window.ArrayHelper = ArrayHelper;
}

class BrowserHelper {

  static detectIE() {
    const ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    const msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    const trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      let rv = ua.indexOf('rv:');
      return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    const edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
  }

  /**
   * query string: ?foo=lorem&bar=&baz
   *
   * getQueryParamByName('foo'); // "lorem"
   * getQueryParamByName('bar'); // ""
   * getParameterByName('baz');  // ""
   * getParameterByName('qux');  // null
   *
   * @param name
   * @param url
   * @returns {*}
   */
  static getQueryParamByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    let regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
    let results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  static getExtension(url) {
    if (!url) return '';
    return url.split('.').pop().split(/\#|\?/)[0];
  }

  static extendSetTimeout(window) {
    let cache = {};

    const _setTimeout = window.setTimeout;
    const _clearTimeout = window.clearTimeout;

    window.setTimeout = function (fn, delay) {
      const id = _setTimeout(function () {
        delete cache[id];  // ensure the map is cleared up on completion
        if (typeof fn === 'function' || typeof eval(fn) === 'function') {
          fn();
        }
      }, delay);
      cache[id] = fn;
      return id;
    };

    window.clearTimeout = function (id) {
      delete cache[id];
      _clearTimeout(id);
    };

    window.getTimeout = function (id) {
      return cache[id];
    };
  }
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = BrowserHelper;
} else {
  window.BrowserHelper = BrowserHelper;
}


const DataConverter = {

  /**
   * 轉換成顯示用的 schedule 資料
   *
   * {...item, mgrs: 'mgr1,mgr2,mgr3'}
   *
   * @param data
   * @param users
   */
  convertViewOfSchedule: function (data, users = []) {
    const result = data.map(item => {
      const mgrs = data
        .filter(each => item.date === each.date && item.staff === each.staff && item.scoreType === each.scoreType && item.table === each.table)
        .map(each => DataConverter.convertUserNameOfEmail(each.mgr, users))
        .join(', ');
      return Object.assign({}, item, {mgrs});
    });
    return result.reduce((pre, cur) => {
      if (!pre.some(item => item.date === cur.date && item.staff === cur.staff && item.scoreType === cur.scoreType && item.table === cur.table)) {
        pre.push(cur);
      }
      return pre;
    }, []);
  },

  convertUserNameOfEmail: function (email, users = []) {
    if (!email || email.length === 0) {
      return email;
    }
    if (users && users.length > 0) {
      const user = users.find(user => email === user.email);
      if (user) {
        return user.name;
      }
    }
    let account = email.replace(/@.*$/, '');
    return account.charAt(0).toUpperCase() + account.slice(1);
  },

  /**
   *
   * @param emailsStr: Is a string, and the connected separator is a comma (', ')
   * @param separator: default is ', '
   * @param users
   */
  convertUserNamesStrOfEmailsStr: function (emailsStr, separator = ', ', users = []) {
    if (!emailsStr || typeof emailsStr !== 'string' || emailsStr.length === 0) {
      return emailsStr;
    }
    const emails = emailsStr.split(separator);
    return emails.map(email => DataConverter.convertUserNameOfEmail(email, users)).join(separator);
  },

  convertHash(str) {
    var hash = 0, i, chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
      chr   = str.charCodeAt(i);
      hash  = ((hash << 5) - hash) + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }

};


if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = DataConverter;
} else {
  window.DataConverter = DataConverter;
}

const FetchHelper = {
  getData: (url,
            successCallback = () => {
            },
            failureCallback = () => {
            },
            beforeSend = () => {
            },
            failure = () => {
            }) => {
    $.ajax({
      type: 'get',
      url,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      beforeSend: function () {
        beforeSend();
      },
      success: function (res) {
        successCallback(res);
      },
      failure: function (errMsg) {
        failureCallback(errMsg);
        console.error(errMsg);
      },
      complete: function () {
        failure();
      }
    });
  },
  getDataByDefault: (url, cb) => {
    FetchHelper.getData(url,
      res => {
        cb(res);
      },
      errMsg => {
        clearAllAlert();
        loggingAlert(errMsg, 'danger');
      },
      () => {
        startLoading();
      },
      () => {
        stopLoading();
      }
    );
  },
  postData: (url,
             data,
             successCallback = () => {
             },
             failureCallback = () => {
             },
             beforeSend = () => {
             },
             failure = () => {
             }) => {
    $.ajax({
      type: 'post',
      url,
      data: JSON.stringify(data),
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      beforeSend: function () {
        beforeSend();
      },
      success: function (res) {
        successCallback(res);
      },
      failure: function (errMsg) {
        failureCallback(errMsg);
        console.error(errMsg);
      },
      complete: function () {
        failure();
      }
    });
  },
  postDataByDefault: (url, data, cb) => {
    FetchHelper.postData(
      url,
      data,
      res => {
        cb(res);
      },
      errMsg => {
        clearAllAlert();
        loggingAlert(errMsg, 'danger');
      },
      () => {
        startLoading();
      },
      () => {
        stopLoading();
      }
    );
  },
};

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = FetchHelper;
} else {
  window.FetchHelper = FetchHelper;
}

const compose = (...fns) =>
  (arg) =>
    fns.reduce(
      (composed, f) => f(composed),
      arg);

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = compose;
} else {
  window.compose = compose;
}
const initDropdown = () => {
  $('.js-dropdown-menu > a.dropdown-item').click(function (evt) {
    evt.preventDefault();
    $(this).parent().parent().find('.js-dropdown-selected')
      .text($(this).text())
      .data('value', $(this).data('value'));
    $(this)
      .addClass('active')
      .siblings().removeClass('active');;
  });
}

if (typeof module !== 'undefined' && typeof module.exports !== 'undefined') {
  module.exports = initDropdown;
} else {
  window.initDropdown = initDropdown;
}
